import { Switch } from '@mui/material';
import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const SwitchRow = ({ label, name, lockName, isLocked, toggleLock, handleChangeRadios }) => {
    const { formState: { errors }, watch } = useFormContext();

    return (
        <div className={`row-primary ${isLocked ? "lock_row" : ""}`}>
            <h2 className="col-6">{label}</h2>
            <Controller
                name={name}
                render={({ field }) => (
                    <div className="switch_row">
                        <Switch
                            className={isLocked ? "lockSwitch" : ""}
                            checked={field.value === true}
                            onChange={() => handleChangeRadios(!field.value, field.onChange)}
                            color="primary"
                            disabled={isLocked}
                        />
                    </div>
                )}
            />
            <button
                name={lockName}
                onClick={() => toggleLock(name, lockName)}
                type="button"
                className={`field_locker ${isLocked ? "itslocked" : ""}`}
            >
                <i className={`fa-solid ${isLocked ? "fa-lock" : "fa-unlock"}`}></i>
            </button>
        </div>
    );
};
const FilterSwitch = ({ setLockStates, item, setValue, lockStates, control, interpretation, translation  }) => {
    const { t } = useTranslation();


    //#region Filter switch work 
    // const fields = [
    //     { label: "US Based Interpreter", name: "us_based", lockable: true, lockName: "us_based_locked" },
    //     { label: "Non US Based Interpreter", name: "non_us_based", lockable: true, lockName: "non_us_based_locked" },
    //     { label: "English To Target Language", name: "english_to_target", lockable: true, lockName: "english_to_target_locked" },
    //     { label: "Spanish To Target Language", name: "spanish_to_target", lockable: true, lockName: "spanish_to_target_locked" },
    //     { label: "Court Certified", name: "court_certified", lockable: true, lockName: "court_certified_locked" },
    //     { label: "Medical Certified", name: "medical_certified", lockable: true, lockName: "medical_certified_locked" },
    // ];

    const interpretationFields = [
        { label: t("filterSwitch.usBasedInterpreter"), name: "us_based", lockable: true, lockName: "us_based_locked" },
        { label: t("filterSwitch.nonUsBasedInterpreter"), name: "non_us_based", lockable: true, lockName: "non_us_based_locked" },
        { label: t("appointmentDetail.englishToTarget"), name: "english_to_target", lockable: true, lockName: "english_to_target_locked" },
        { label: t("appointmentDetail.spanishToTarget"), name: "spanish_to_target", lockable: true, lockName: "spanish_to_target_locked" },
        { label: t("appointmentDetail.courtCertified"), name: "court_certified", lockable: true, lockName: "court_certified_locked" },
        { label: t("appointmentDetail.medicalCertified"), name: "medical_certified", lockable: true, lockName: "medical_certified_locked" },
    ];

    const translationFields = [
        { label: t("filterSwitch.templeRecommend"), name: "temple_recommend", lockable: true, lockName: "temple_recommend_locked" },
    ];

    const fields = [...interpretationFields, ...translationFields];

    useEffect(() => {
        if (item?.filters) {
            fields.forEach((field) => {
                setValue(field.name, !!item.filters[field.name]);
                setLockStates((prev) => ({ ...prev, [field.name]: !!item.filters[field.lockName] }));
            });
        }
    }, [item]);

    useEffect(() => {
        if (translation !== 1) {
            setValue("temple_recommend", false);
            setLockStates((prev) => ({ ...prev, temple_recommend: false }));
        }
    }, [translation]);

    const toggleLock = (name, lockName) => {
        setLockStates((prevState) => {
            const updatedState = { ...prevState, [name]: !prevState[name] };
            setValue(lockName, updatedState[name]);
            return updatedState;
        });
    };
    const handleChangeRadios = (value, onChange) => {
        onChange(value);
    };
    //#endregion
    return (
        <>
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>{t("appointmentForm.filters")}</h2>
            </div>
            <div className='Filter_wrapper'>
                {/* {fields.map((field) => ( */}
                {interpretation == 1 && interpretationFields.map((field) => (
                    <SwitchRow
                        key={field.name}
                        label={field.label}
                        name={field.name}
                        lockName={field.lockName}
                        isLocked={lockStates[field.name]}
                        toggleLock={toggleLock}
                        handleChangeRadios={handleChangeRadios}
                        control={control}
                    />
                ))}

                {translation == 1 && translationFields.map((field) => (
                    <SwitchRow
                        key={field.name}
                        label={field.label}
                        name={field.name}
                        lockName={field.lockName}
                        isLocked={lockStates[field.name]}
                        toggleLock={toggleLock}
                        handleChangeRadios={handleChangeRadios}
                        control={control}
                    />
                ))}
            </div>
        </>
    )
}

export default FilterSwitch